import { atom, useAtom } from 'jotai';

const loadingAtom = atom<boolean>(false);

const useLoading = () => {
  const [isLoading, setIsLoading] = useAtom(loadingAtom);

  const showLoading = () => {
    setIsLoading(true);
  };

  const hideLoading = () => {
    setIsLoading(false);
  };

  return {
    isLoading,
    showLoading,
    hideLoading,
  };
};

export default useLoading;
